<template>
  <div class="summary-leave-container">
    <a-skeleton :loading="loading" active avatar :paragraph="{ rows: 4 }">
      <a-list size="small" :bordered="false" :data-source="dataAbsence">
        <a-list-item slot="renderItem" slot-scope="item, index" class="px-0 py-12">
          <a-list-item-meta>
            <span slot="title" class="leave-title">{{ item.toppic }}</span>
            <a-avatar slot="avatar" :src="item.icon" shape="square" :size="32" class="leave-icon-img" />
            <div slot="description" class="leave-description">
               <span v-if="item.limit && item.limit !== '-'">Limit: {{ item.limit }} days</span>
               <span v-else-if="item.limit === '-'">No fixed limit</span>
               <span v-else>Check details</span>
            </div>
          </a-list-item-meta>
          <div slot="actions" class="leave-usage">
            <div class="usage-box">
              <span class="used-value">{{ item.used || '0' }}</span>
              <span class="used-label">Used</span>
            </div>
          </div>
        </a-list-item>
      </a-list>
    </a-skeleton>
  </div>
</template>

<script>
export default {
  name: 'SummaryLeave',
  props: {
    leaveSummary: {
      type: Object,
      default: () => ({}),
    },
    vacationLimit: {
      type: [Number, String],
      default: 0,
    },
    casualLimit: {
      type: [Number, String],
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataAbsence() {
      const summary = this.leaveSummary || {};
      return [
        {
          index: 1,
          icon: '/images/holiday-icon.png',
          toppic: 'Vacation leave',
          used: summary.vacation || '0',
          nameObj: 'vacation',
          limit: this.vacationLimit || '0',
        },
        {
          index: 2,
          icon: '/images/sick-icon-1.png',
          toppic: 'Sick leave',
          used: summary.sick || '0',
          nameObj: 'sick',
          limit: '60',
        },
        {
          index: 3,
          icon: '/images/sick-icon.png',
          toppic: 'Medical Leave',
          used: summary.medical || '0',
          nameObj: 'medical',
          limit: '120',
        },
        {
          index: 4,
          icon: '/images/extra-icon-other.png',
          toppic: 'Extra Leave',
          used: summary.extra || '0',
          nameObj: 'extra',
          limit: '-',
        },
        {
          index: 5,
          icon: '/images/leave-icon.png',
          toppic: 'Casual leave',
          used: summary.casual || '0',
          nameObj: 'casual',
          limit: this.casualLimit ? `${this.casualLimit} *` : '0 *',
        },
      ];
    },
  },
}
</script>

<style scoped>
.summary-leave-container {
  font-family: 'Inter', sans-serif;
}
.quota-header {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}
.quota-title {
  font-size: 14px;
  font-weight: 600;
  color: #8c8c8c;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.mb-15 { margin-bottom: 15px; }
.px-0 { padding-left: 0 !important; padding-right: 0 !important; }
.py-12 { padding-top: 12px !important; padding-bottom: 12px !important; }

.leave-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
}

.leave-icon-img {
  background: transparent;
  padding: 2px;
}

.leave-description {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: -2px;
}

.leave-usage {
  margin-left: 16px;
}

.usage-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f9fa;
  padding: 4px 12px;
  border-radius: 8px;
  min-width: 60px;
}

.used-value {
  font-size: 16px;
  font-weight: 800;
  color: #4285F4;
  line-height: 1.2;
}

.used-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #b0b0b0;
  font-weight: 600;
}

::v-deep .ant-list-item-meta-avatar {
  margin-right: 12px;
}

::v-deep .ant-list-item-meta-title {
  margin-bottom: 0px;
}
</style>
